import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="oferta" className="py-24 px-4 bg-warm-bg" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <h2 className="text-4xl md:text-5xl font-black text-warm-dark mb-6" data-id="element-114">
          Protege la Salud Emocional de tu Atleta Hoy Mismo
        </h2>

        <p className="text-lg text-warm-mid mb-16 max-w-xl mx-auto" data-id="element-115">
          Obtén el sistema completo de Mente de Campeón por un pago único.
        </p>

        <div className="border border-warm-dark/15 rounded-sm p-8 md:p-12 max-w-lg mx-auto bg-warm-light" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/1WSyFrSao2CF5DLJvyKK6j/heylloyd-image-1772653878930.png" alt="Mente de Campeón Inquebrantable" className="w-44 mx-auto mb-8" data-id="element-117" />

          <p className="text-warm-mid line-through text-sm mb-2" data-id="element-118">
            Valor Regular: $29.00
          </p>

          <div className="text-5xl font-black text-warm-dark mb-2" data-id="element-119">$6.39</div>

          <p className="text-xs text-warm-mid uppercase tracking-widest font-heading mb-8" data-id="element-120">
            Precio especial de lanzamiento
          </p>

          <Button className="w-full mb-6" onClick={() => {
          trackAddToCart();
          window.open('https://enfoquedeacero.com/cart/44845085818982:1', '_blank');
        }} data-id="element-121">
            Quiero ayudar a mi hijo ahora
            <ArrowRightIcon className="w-5 h-5" data-id="element-122" />
          </Button>

          <p className="text-warm-mid text-xs leading-relaxed" data-id="element-123">
            Acceso inmediato tras la compra. Formato digital PDF compatible con
            todos los dispositivos.
          </p>
        </div>
      </div>
    </section>;
}